<template>  
    <div :style="shu.yangshi" class="zidingyi_shiping">
		<el-image :src="shu.shu.tu" v-if="shu.shu" :style="yangshi"></el-image>
		<!-- <video id="myVideo" :src="shu.shu.tu" v-if="shu.shu"  @error="videoErrorCallback" controls :style="yangshi"></video> -->
		<div class="el-icon-caret-left bofan" :style="yangshis"></div>
	</div> 	
</template>

<script>
export default {
  name: 'shiping',
  props: {
       shu: {
		   type:Object,
		   default(){
			   return {wenzi:'输入文字',yangshi:{}}
		   }
		}
  },
  data(){
	  return{
		  yangshi:'',
		  yangshis:''
	  }
  },
  mounted() {
  	if (!this.shu.shu) {
  		this.$set(this.shu, 'shu', {					
  			tu: 'https://limitao.myuan.cn/gongyong/shangchuan/tu/12/2019/11/r7Rc8mBC1BeuLcerUEUY7u22M7p12R.png',
  			url:''
  		})
  	}
	if (!this.shu.yangshi) {
		this.$set(this.shu, 'yangshi', {})
	}	
	if (!this.shu.yangshis) {
		this.$set(this.shu, 'yangshis', {})
	}
  },
  watch: {
	  // 图
  	'shu.yangshi.width':function(){
  		this.Ys();
  	},
  	'shu.yangshi.height':function(){
  		this.Ys();
  	},
  	'shu.yangshi.text_align':function(){
  		this.Ys();
  	},
  	'shu.yangshi.margin':function(){
  		this.Ys();
  	},
  	'shu.yangshi.padding':function(){
  		this.Ys();
  	},
  	'shu.yangshi.border_radius':function(){
  		this.Ys();
  	},
	// 播放按钮
	
	'shu.yangshis.width':function(){
		this.Yss();
	},
	'shu.yangshis.height':function(){
		this.Yss();
	},
	'shu.yangshis.text_align':function(){
		this.Yss();
	},
	'shu.yangshis.margin':function(){
		this.Yss();
	},
	'shu.yangshis.padding':function(){
		this.Yss();
	},
	'shu.yangshis.color':function(){
		this.Yss();
	},
	'shu.yangshis.font_size':function(){
		this.Yss();
	},
  },
  methods:{
  	Ys(){
  		this.yangshi = "";
  		var px='';
  		if (this.shu.yangshi.width) {
  			px=(this.shu.yangshi.width>0)?(this.shu.yangshi.width+'px'):this.shu.yangshi.width;					
  			this.yangshi += "width:" +px+ ";";
  		}
  		if (this.shu.yangshi.height) {				
  			px=(this.shu.yangshi.height>0)?(this.shu.yangshi.height+'px'):this.shu.yangshi.height;		
  			this.yangshi += "height:" + px+ ";";
  		}
  		if (this.shu.yangshi.text_align) {				
  			this.yangshi += "text-align:" + this.shu.yangshi.text_align+ ";";
  		}	
  		if (this.shu.yangshi.margin) {
  			px=(this.shu.yangshi.margin>0)?(this.shu.yangshi.margin+'px'):this.shu.yangshi.margin;		
  			this.yangshi += "margin:" + px+ ";";
  		}
  		if (this.shu.yangshi.padding) {
  			px=(this.shu.yangshi.padding>0)?(this.shu.yangshi.padding+'px'):this.shu.yangshi.padding;		
  			this.yangshi += "padding:" + px+ ";";
  		}
  		if (this.shu.yangshi.border_radius) {
  			px=(this.shu.yangshi.border_radius>0)?(this.shu.yangshi.border_radius+'px'):this.shu.yangshi.border_radius;		
  			this.yangshi += "border-radius:" + px+ ";";
  		}
  		console.log(this.yangshi)
  	},
	Yss(){
		this.yangshis = "";
		var px='';
		if (this.shu.yangshis.width) {
			px=(this.shu.yangshis.width>0)?(this.shu.yangshis.width+'px'):this.shu.yangshis.width;					
			this.yangshis += "width:" +px+ ";";
		}
		if (this.shu.yangshis.height) {				
			px=(this.shu.yangshis.height>0)?(this.shu.yangshis.height+'px'):this.shu.yangshis.height;		
			this.yangshis += "height:" + px+ ";";
		}
		if (this.shu.yangshis.text_align) {				
			this.yangshis += "text-align:" + this.shu.yangshis.text_align+ ";";
		}	
		if (this.shu.yangshis.margin) {
			px=(this.shu.yangshis.margin>0)?(this.shu.yangshis.margin+'px'):this.shu.yangshis.margin;		
			this.yangshis += "margin:" + px+ ";";
		}
		if (this.shu.yangshis.padding) {
			px=(this.shu.yangshis.padding>0)?(this.shu.yangshis.padding+'px'):this.shu.yangshis.padding;		
			this.yangshis += "padding:" + px+ ";";
		}
		if (this.shu.yangshis.color) {
			this.yangshis += "color:" + this.shu.yangshis.color+ ";";
		}
		if (this.shu.yangshis.font_size) {
			px=(this.shu.yangshis.font_size>0)?(this.shu.yangshis.font_size+'px'):this.shu.yangshis.font_size;		
			this.yangshis += "font-size:" + px+ ";";
		}
		console.log(this.yangshis)
	}
  }
}
</script>



